import { css } from 'react-emotion'

const styles = {
  accordion: css({
    userSelect: 'none',
  }),
  title: css({
    display: 'flex',
    flexDirection: 'column'
  }),
  accordionHead: css({
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: '#ede7f6',
    }
  }),
  teamName: css({
    fontSize: '1rem',
    fontWeight: 'bold',
    margin: '8px 8px 2px 24px',
    color: 'rgb(80, 80, 120)',
  }),
  noOfProjects: css({
    fontSize: '0.8rem',
    color: 'rgb(181, 181, 200)',
    margin: '2px 8px 8px 24px'
  }),
  accordionBody: css({
    transition: 'height .35s ease-in-out',
    overflow: 'hidden'
  }),
  accordionPanel: css({
    overflow: 'hidden',

    '&[isopen="false"]': {
      height: '0',
    },

    '&[isopen="true"]': {
      height: 'auto',
    }
  }),
  project: (isActiveProject) => {
    let style = {
      paddingLeft: '16px',
      cursor: 'pointer',

      '&:hover': {
        backgroundColor: 'rgba(182, 194, 252, 0.1)',
      }
    }
    if (isActiveProject) {
      style.borderLeft = '4px solid #7A68F2'
      style.paddingLeft = '12px'
      style.backgroundColor = 'rgba(172, 154, 252, 0.1)'
    }
    return css(style)
  },
  projectName: css({
    fontSize: '1rem',
    fontWeight: 'bold',
    padding: '8px 8px 2px 24px',
    color: 'rgb(80, 80, 120)',
  }),
  noOfVideos: css({
    fontSize: '0.8rem',
    color: 'rgb(181, 181, 200)',
    padding: '2px 8px 8px 24px'
  }),
  addButton: css({
    display: 'flex',
    alignItems: 'center'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/SideBarLeft/AccordionStyles.js